export default "__VITE_ASSET__BiDSFIz8__"